import PropTypes from 'prop-types';
import React, { Component } from 'react';
import map from 'lodash/map';
import CalendarWidget from './containers/SideBySideCalendarWidget';

class SideBySideCalendars extends Component {
  static barber = {
    color: '#000000',
    id: -1,
    firstName: 'Y',
    lastName: 'Axis',
  };

  render() {
    const { barbersViewed, calendarWorkDay, blockedTimes, workday } = this.props;
    const timeColumnHack = (
      <CalendarWidget
        key={-1}
        barber={SideBySideCalendars.barber}
        calendarClass="c-calendar-dayview c-calendar-dayview--hasaxis fc fc-unthemed"
        calendarWorkDay={calendarWorkDay}
      />
    );

    const calendars = map(barbersViewed, barber => (
      <CalendarWidget
        key={barber.id}
        barber={barber}
        calendarClass="c-calendar-dayview c-calendar-dayview--notimeaxis fc fc-unthemed"
        calendarWorkDay={calendarWorkDay}
        blockedTimes={blockedTimes[barber.id]}
        workday={workday[barber.id]}
      />
    ));

    const showCalendars = (
      <div className="c-calendar-dayview-wrapper">
        { timeColumnHack }
        { calendars }
      </div>
    );

    return barbersViewed.length > 0 ? showCalendars : null;
  }
}

SideBySideCalendars.propTypes = {
  barbersViewed: PropTypes.arrayOf(PropTypes.object).isRequired,
  calendarWorkDay: PropTypes.object.isRequired,
  blockedTimes: PropTypes.object.isRequired,
  workday: PropTypes.object.isRequired,
};

export default SideBySideCalendars;
